"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentDidCatch = exports.ComponentDidCatch = void 0;
var React = __importStar(require("react"));
var widgets_main_1 = require("../widgets-main");
var ComponentDidCatch = /** @class */ (function (_super) {
    __extends(ComponentDidCatch, _super);
    function ComponentDidCatch(props) {
        var _this = _super.call(this, props) || this;
        _this.state = (0, widgets_main_1.none)();
        return _this;
    }
    ComponentDidCatch.prototype.componentDidCatch = function (error, errorInfo) {
        this.setState((0, widgets_main_1.some)([error, errorInfo]));
    };
    ComponentDidCatch.prototype.render = function () {
        if (this.state.kind == "l") {
            return this.props.children;
        }
        else {
            return (this.props.catch || (function (_) { return (0, widgets_main_1.nothing)(); }))(this.state.v).run(this.props.onDone);
        }
    };
    return ComponentDidCatch;
}(React.Component));
exports.ComponentDidCatch = ComponentDidCatch;
var componentDidCatch = function (key, component, fallback) { return (0, widgets_main_1.fromJSX)(function (setState) { return React.createElement(ComponentDidCatch, {
    onDone: setState,
    catch: fallback,
    key: key
}, [component.run(setState)]); }); };
exports.componentDidCatch = componentDidCatch;
